import React from "react";
import styles from "./HomeView.less";
export class HomeView extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.contents },
                React.createElement("span", { className: styles.title }, "Welcome to"),
                React.createElement("span", { className: styles.logo }))));
    }
}
